import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateMovementJobComponent } from '../../components/create-movement-job/create-movement-job.component';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { AutoCompleteModule, EditorModule, TableModule } from 'primeng';
import { OverlayPanelInputComponent } from '../../user-controls/overlay-panel-input/overlay-panel-input.component';
import { CustomerSitesModule } from '../../components/customer-sites/customer-sites.module';
import { DuplicateTasksDialogComponent } from '../../components/create-movement-job/duplicate-tasks-dialog.component';
import { ManualAddressEntryAlertComponent } from '../../components/create-movement-job/manual-address-entry-alert/manual-address-entry-alert.component';
import { VehicleKerbWeightInputComponent } from '../../components/create-movement-job/vehicle-kerb-weight-input/vehicle-kerb-weight-input.component';
import { BookingWarningsComponent } from '../../components/create-movement-job/booking-warnings/booking-warnings.component';
import { WarningContainerComponent } from '../../components/create-movement-job/warning-container/warning-container.component';

const routes: Routes = [{ path: '', component: CreateMovementJobComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateMovementJobRoutingModule {}

@NgModule({
  imports: [
    CreateMovementJobRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
    EditorModule,
    OverlayPanelInputComponent,
    CustomerSitesModule,
    AutoCompleteModule,
    ManualAddressEntryAlertComponent,
    VehicleKerbWeightInputComponent,
    BookingWarningsComponent,
    WarningContainerComponent,
  ],
  declarations: [CreateMovementJobComponent, DuplicateTasksDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreateMovementJobModule {}
